"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ScreenSizeWarning = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propTypesExact = _interopRequireDefault(require("prop-types-exact"));

var _withWindowDimensions = _interopRequireDefault(require("./withWindowDimensions"));

var _ScreenTooSmallIcon = require("./icons/ScreenTooSmallIcon");

var _XIcon = _interopRequireDefault(require("./icons/XIcon"));

var _excluded = ["backgroundColor", "zIndex"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/*
 Displays a fixed full screen warning when screen size gets too small.
 See screensize.stories.js for example usage.
*/
var Background = _styled["default"].div(function (_ref) {
  var backgroundColor = _ref.backgroundColor,
      _ref$zIndex = _ref.zIndex,
      zIndex = _ref$zIndex === void 0 ? 1000 : _ref$zIndex,
      props = _objectWithoutProperties(_ref, _excluded);

  return {
    position: "fixed",
    left: 0,
    right: 0,
    bottom: 0,
    top: 0,
    backgroundColor: backgroundColor,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "Effra, Arial",
    zIndex: zIndex
  };
});

var Content = _styled["default"].div({
  display: "flex",
  flexDirection: "column",
  maxWidth: 419,
  alignItems: "center"
});

var Header = _styled["default"].div({
  color: "#4F4F4F",
  textAlign: "center",
  fontSize: 24,
  marginTop: 30,
  fontWeight: "bold"
});

var SubHeader = _styled["default"].div({
  color: "#4F4F4F",
  textAlign: "center",
  fontSize: 16,
  fontWeight: "bold"
});

var DismissButton = _styled["default"].button({
  position: "fixed",
  right: 25,
  top: 25,
  textAlign: "center",
  border: "none",
  outline: "none",
  background: "none",
  cursor: "pointer"
});

var ScreenSizeWarning = /*#__PURE__*/function (_PureComponent) {
  _inherits(ScreenSizeWarning, _PureComponent);

  var _super = _createSuper(ScreenSizeWarning);

  function ScreenSizeWarning() {
    var _this;

    _classCallCheck(this, ScreenSizeWarning);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      dismissed: false,
      undersized: false
    });

    _defineProperty(_assertThisInitialized(_this), "dismiss", function () {
      _this.setState({
        dismissed: true
      }, function () {
        _this.props.onDismissed && _this.props.onDismissed();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "undersized", function () {
      return _this.props.clientWidth < _this.props.minWidth || _this.props.clientHeight < _this.props.minHeight;
    });

    _defineProperty(_assertThisInitialized(_this), "visible", function () {
      return !_this.props.disabled && !_this.state.dismissed && _this.undersized();
    });

    _defineProperty(_assertThisInitialized(_this), "lastVisible", false);

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var visible = _this.visible();

      if (_this.lastVisible !== visible) {
        if (visible) {
          _this.props.onTooSmall && _this.props.onTooSmall();
        }
      }

      _this.lastVisible = visible;
      if (!_this.visible()) return null;
      return /*#__PURE__*/_react["default"].createElement(Background, {
        "data-qa": "ScreenSizeWarning",
        zIndex: _this.props.zIndex,
        backgroundColor: _this.props.backgroundColor
      }, /*#__PURE__*/_react["default"].createElement(DismissButton, {
        "data-qa": "ScreenSizeWarningDismissButton",
        onClick: _this.dismiss
      }, /*#__PURE__*/_react["default"].createElement(_XIcon["default"], {
        width: 14,
        height: 14
      })), /*#__PURE__*/_react["default"].createElement(Content, null, /*#__PURE__*/_react["default"].createElement(_ScreenTooSmallIcon.ScreenTooSmallIcon, null), /*#__PURE__*/_react["default"].createElement(Header, {
        "data-qa": "ScreenSizeWarningHeader"
      }, _this.props.headerText), /*#__PURE__*/_react["default"].createElement(SubHeader, {
        "data-qa": "ScreenSizeWarningSubHeader"
      }, _this.props.subheaderText)));
    });

    return _this;
  }

  return ScreenSizeWarning;
}(_react.PureComponent);

exports.ScreenSizeWarning = ScreenSizeWarning;

_defineProperty(ScreenSizeWarning, "propTypes", (0, _propTypesExact["default"])({
  minWidth: _propTypes["default"].number.isRequired,
  // Screen width to trigger at
  minHeight: _propTypes["default"].number.isRequired,
  // Screen height to trigger at
  disabled: _propTypes["default"].bool,
  // Set disabled to prevent the warning from ever coming up
  onTooSmall: _propTypes["default"].func,
  // Called when the screensize goes too small (optional)
  backgroundColor: _propTypes["default"].string,
  onDismissed: _propTypes["default"].func
  /* Called when the warning is dismissed, this could
                  happen because the user resizes the window, or they
                  click the X (optional)*/
  ,
  clientWidth: _propTypes["default"].number.isRequired,
  // Filled in by withWindowDimensions
  clientHeight: _propTypes["default"].number.isRequired,
  // Filled in by withWindowDimensions
  headerText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element // allows us to use <LionTranslate /> component here instead of a raw string
  ]),
  subheaderText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element // allows us to use <LionTranslate /> component here instead of a raw string
  ]),
  zIndex: _propTypes["default"].number
}));

_defineProperty(ScreenSizeWarning, "defaultProps", {
  disabled: false,
  minWidth: 1024,
  minHeight: 768,
  backgroundColor: "#F1F1F1",
  zIndex: 1000
});

var _default = (0, _withWindowDimensions["default"])(ScreenSizeWarning);

exports["default"] = _default;